<div class="color-bar"></div>

<div>    
    <app-bi-spuio-lista
        [filtros]="filtros"
        (exibir)="selecionar($event)">    
    </app-bi-spuio-lista>
</div>
